// Analytics utilities for Google Analytics 4
declare global {
  interface Window {
    gtag: (command: string, ...args: any[]) => void;
  }
}

/**
 * Track a page view in Google Analytics
 */
export const trackPageView = (url: string, title?: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', 'G-VYPNQ64CDQ', {
      page_path: url,
      page_title: title || document.title,
      page_location: window.location.origin + url
    });
  }
};

/**
 * Track custom events in Google Analytics
 */
export const trackEvent = (action: string, category?: string, label?: string, value?: number) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value
    });
  }
};

/**
 * Track newsletter signups
 */
export const trackNewsletterSignup = () => {
  trackEvent('newsletter_signup', 'engagement', 'newsletter_form');
};

/**
 * Track external link clicks
 */
export const trackExternalLink = (url: string, source: string) => {
  trackEvent('click', 'external_link', `${source}: ${url}`);
};